module.exports = __webpack_public_path__ + "assets/HKNova-Heavy.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Heavy.ttf
// module id = 125
// module chunks = 0